/** Survey JSON bundles (edit JSON + save; dev server reloads imports). */
import addEventForm from '../components/duna/duna-add-event/add-event.json';
import addEventUsersForm from '../components/duna/duna-add-event-users/add-users-to-event.json';
import editEventForm from '../components/duna/duna-edit-event/edit-event.json';
import eventUserParticipateForm from '../components/duna/duna-user-participate/event-user-participate-form.json';

export type BundledSurveyFormId =
  | 'add-event'
  | 'add-event-users'
  | 'edit-event'
  | 'event-user-participate-form';

const BUNDLED_SURVEY_FORMS: Record<
  BundledSurveyFormId,
  Record<string, unknown>
> = {
  'add-event': addEventForm as Record<string, unknown>,
  'add-event-users': addEventUsersForm as Record<string, unknown>,
  'edit-event': editEventForm as Record<string, unknown>,
  'event-user-participate-form': eventUserParticipateForm as Record<
    string,
    unknown
  >,
};

/** Relative path from repo root for template-generator / edit-modal hints. */
export const BUNDLED_SURVEY_FORM_SOURCE: Record<BundledSurveyFormId, string> = {
  'add-event': 'src/app/components/duna/duna-add-event/add-event.json',
  'add-event-users':
    'src/app/components/duna/duna-add-event-users/add-users-to-event.json',
  'edit-event': 'src/app/components/duna/duna-edit-event/edit-event.json',
  'event-user-participate-form':
    'src/app/components/duna/duna-user-participate/event-user-participate-form.json',
};

export function isBundledSurveyFormId(
  id: string | null | undefined
): id is BundledSurveyFormId {
  return (
    id === 'add-event' ||
    id === 'add-event-users' ||
    id === 'edit-event' ||
    id === 'event-user-participate-form'
  );
}

export function resolveBundledSurveyForm(
  id: string | null | undefined
): Record<string, unknown> | null {
  if (!isBundledSurveyFormId(id)) {
    return null;
  }
  const template = BUNDLED_SURVEY_FORMS[id];
  return JSON.parse(JSON.stringify(template)) as Record<string, unknown>;
}

export function getBundledSurveyFormIdFromComponentInputs(
  inputs: Record<string, { value?: unknown }> | undefined
): BundledSurveyFormId | null {
  const raw = inputs?.['bundledSurveyForm']?.value;
  if (typeof raw !== 'string' || !raw.trim()) {
    return null;
  }
  const id = raw.trim();
  return isBundledSurveyFormId(id) ? id : null;
}
